import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const BalanceIndex = lazy(() => import('./balance/Index'))
const CategoryIndex = lazy(() => import('./category/Index'))
const TemplateIndex = lazy(() => import('./template/Index'))
const DayIndex = lazy(() => import('./day/Index'))

export const RosterRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--human-resources--roster']}>
    <Route index element={<Index />} />
    <Route path='balance' element={<BalanceIndex />} />
    <Route path='category/*' element={<CategoryIndex />} />
    <Route path='template/*' element={<TemplateIndex />} />
    <Route path='day/*' element={<DayIndex />} />
  </SubRouter>
))
